@if (value$ | async; as value) {
  <div class="wrapper">
    @if (codeForm) {
      <form [formGroup]="codeForm()">
        <div class="info">
          @if (email()) {
            <p class="explain">{{ 'SIGN.EVCV' | translate }}</p>
            <p class="email">{{ email() }}</p>
          } @else {
            <p class="explain">{{ 'SIGN.EVCC' | translate }}</p>
            <p class="email">{{ phone() | phoneNumber }}</p>
          }
        </div>
        <app-code-input (onEnter)="submitCode(value)" />

        @if (showWarning$ | async; as warning) {
          <div class="warning">
            <p class="message">{{ warning | translate }}</p>
          </div>
        } @else {
          <br />
        }
        <div class="submit-spinner">
          <app-submit-spinner
            [loading]="loading()"
            [label]="'SIGN.VC'"
            [isValid]="codeForm().valid"
            (click)="submitCode(value)"
          />
        </div>
      </form>
    }
  </div>
}
